/** Case-insensitive substring match; empty needle matches everything. */
export function includesCI(hay, needle) {
  if (!needle || !String(needle).trim()) return true;
  const n = String(needle).trim().toLowerCase();
  const h = String(hay ?? '').toLowerCase();
  return h.includes(n);
}

/** Case-insensitive exact match; empty needle matches everything. */
export function equalsCI(a, b) {
  if (!b || !String(b).trim()) return true;
  return String(a ?? '').trim().toLowerCase() === String(b).trim().toLowerCase();
}

export function buildSelectOptions(placeholderLabel, values, currentValue) {
  const seen = new Set();
  const sorted = (values || [])
    .map((v) => (v == null ? '' : String(v).trim()))
    .filter((v) => v)
    .filter((v) => {
      if (seen.has(v)) return false;
      seen.add(v);
      return true;
    })
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
  const opts = [{ value: '', label: placeholderLabel }, ...sorted.map((v) => ({ value: v, label: v }))];
  if (currentValue && !opts.some((o) => o.value === currentValue)) {
    opts.push({ value: currentValue, label: currentValue });
  }
  return opts;
}

export function collectUniqueStrings(rows, pick) {
  const out = [];
  const seen = new Set();
  for (const row of rows || []) {
    const v = pick(row);
    if (v == null) continue;
    const s = String(v).trim();
    if (!s || seen.has(s)) continue;
    seen.add(s);
    out.push(s);
  }
  return out;
}
